export default function host() {
  const host = window.location.host;
  const href = window.location.href;
  const protocol = href.indexOf('https') != -1 ? 'https://' : 'http://';
  let hostname = window.location.hostname;
  let _lang = 'en';

  if(host.indexOf('kqbd') != -1){
    return protocol + 'kqbd.upgoal.com/api/'
  }

  if(host.indexOf('score66') != -1){
    return protocol + 'www.score66.com/api/'
    //return protocol + 'score66.upgoal.com/api/'
  }

  if(hostname.indexOf('en') > -1){
    _lang = 'en';
  }
  if(hostname.indexOf('kr') > -1){
    _lang = 'kr';
  }
  if(hostname.indexOf('th') > -1){
    _lang = 'th';
  }
  if(hostname.indexOf('vn') > -1){
    _lang = 'vn';
  }

  if(host.indexOf('dev') != -1 || host.indexOf('localhost') != -1 || host.indexOf('127.0.0.1') != -1){
    return protocol+ _lang + '.dev.upgoal.com/api/';
  }
  if(host.indexOf('test') != -1){
    return protocol+ _lang + '.test.upgoal.com/api/';
  }
  if(host.indexOf('staging') != -1){
    return protocol+ _lang + '.staging.upgoal.com/api/';
  }
  return protocol+ _lang + '.upgoal.com/api/';
}


// WEBPACK FOOTER //
// ./src/utils/host.js